<template>
  <Modal
    width="500px"
    :btns="modalBtns"
    :title="props.title"
    class="permission-modal"
    wrapClassName="no-border"
    @open="handleOpen"
    @close="emit('close')"
  >
    <div class="manage-body">
      <!-- <TableItemSelect
        v-for="m in currentMembers"
        :key="m.id"
        :member="m"
        :selected="selected.some(s => s.userId === m.userId)"
        @select="c => handleSelect(m, c)"
      ></TableItemSelect> -->
      <div
        class="member-item-new hover-trigger manage-item"
        v-for="(member, index) in currentMembers"
        :key="member.userId"
        tabindex="1"
      >
        <div class="name">
          <Avatar :name="member.name" :url="previewFile(member.avatar)"></Avatar>
          <div class="flex-1">
            <div class="flex items-center">
              <div>{{ member.employeeName }}</div>
              <div class="account hover-item">(ID: {{ member.loginName }})</div>
            </div>
            <div class="email">{{ member.email }}</div>
          </div>
        </div>
        <a-dropdown
          :disabled="member.memberPermission === 'owner'"
          :trigger="['click']"
          :overlayClassName="'right-dropdown'"
          placement="bottomRight"
        >
          <div class="flex items-center">
            <div :class="member.memberPermission !== 'owner' ? 'right-name' : 'right-first'">
              {{ getPermissionShortDesc(member.memberPermission) }}
            </div>
            <div class="right-icon" v-show="member.memberPermission !== 'owner'">▾</div>
          </div>
          <template #overlay>
            <a-menu @click="changeCurrentPermission($event, index)">
              <a-menu-item key="manager">
                <template #icon>
                  <CheckOutlined v-if="member.memberPermission === 'manager'"></CheckOutlined>
                  <div v-else></div>
                </template>
                <div class="operate-name">可管理（可删除、编辑、下载、移动）</div>
              </a-menu-item>
              <a-menu-item key="editor">
                <template #icon>
                  <CheckOutlined v-if="member.memberPermission === 'editor'"></CheckOutlined>
                  <div v-else></div>
                </template>
                <div class="operate-name">可编辑（可编辑、下载、移动）</div>
              </a-menu-item>
              <a-menu-item key="viewer">
                <template #icon>
                  <CheckOutlined v-if="member.memberPermission === 'viewer'"></CheckOutlined>
                  <div v-else></div>
                </template>
                <div class="operate-name">可查看（仅支持在线浏览）</div>
              </a-menu-item>
              <a-menu-divider></a-menu-divider>
              <a-menu-item key="owner">
                <template #icon><div></div> </template>
                <div class="operate-name">设为拥有者</div>
              </a-menu-item>
              <a-menu-divider></a-menu-divider>
              <a-menu-item key="remove">
                <template #icon><div></div> </template>
                <div class="operate-name">移除</div>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
    </div>
    <Modal
      class="permission-modal"
      width="600px"
      title="添加成员"
      v-model:visible="addVisible"
      @ok="handleOk"
      @close="handleClose"
    >
      <div class="flex flex-col add-body">
        <div class="search-input-wrapper">
          <Input class="search-input" placeholder="搜索成员" v-model:value="memberKeywords">
            <template #prefix>
              <search-outlined class="certain-category-icon" />
            </template>
          </Input>
        </div>
        <div class="flex-1 overflow-y-auto overflow-x-hidden hover-scroll px-4">
          <TableItemSelect
            v-for="m in membersToSelect"
            :key="m.id"
            :member="m"
            :selected="selected.some(s => s.userId === m.userId)"
            @select="c => handleSelect(m, c)"
          ></TableItemSelect>
        </div>
      </div>
    </Modal>
  </Modal>
</template>

<script setup lang="ts">
import { Input, Tree, type TreeProps } from 'ant-design-vue'
import { CheckOutlined, SearchOutlined } from '@ant-design/icons-vue'
import type { CadFolderMemberVo, CadProjectShortVo } from '@elecmap/api/src/cad/space.d'
import { Avatar, Modal } from '@elecmap/elecmap-ui'
import { computed, ref, shallowRef, useAttrs, watch } from 'vue'
import {
  getDepartmentTreeData,
  getMemberList,
  listDepartmentEmployeeTree,
} from '@elecmap/api/src/ram'
import type { Department, EmployeePageQuery, EmployeeVo } from '@elecmap/api/src/ram.d'
import type { MemberPermission } from '@elecmap/api/src/cad/shared.d'
import { previewFile } from '@elecmap/api/src/cad/file'
import TableItemSelect from './MemberTable/table-item-select.vue'
import { arrayToRecord } from '@elecmap/shared/src/utils/utils'

const props = defineProps<{
  title?: string
  members?: CadFolderMemberVo[]
}>()

const emit = defineEmits(['close', 'ok', 'transferOwner'])

const selected = ref<any[]>([])
const orgMemberTree = ref<Department[]>([])
const rawTree = shallowRef()
const allMembers = ref<EmployeePageQuery[]>([])
const addVisible = ref(false)
const memberKeywords = ref<string>()

/**
 * 过滤已经是的
 */
const membersToSelect = computed(() => {
  const notSelected = allMembers.value.filter(
    m => !props.members?.some(m1 => m.userId === m1.userId),
  )
  if (!memberKeywords.value) return notSelected
  return notSelected.filter(m =>
    m.employeeName.toLowerCase().includes(memberKeywords.value.toLowerCase()),
  )
})

const currentMembers = computed<(EmployeePageQuery & { memberPermission: MemberPermission })[]>(
  () => {
    const obj = arrayToRecord(allMembers.value, 'userId')
    return props.members.map(m => ({
      ...m,
      ...obj[m.userId],
    })) as (EmployeePageQuery & { memberPermission: MemberPermission })[]
  },
)

function handleSelect(m: EmployeePageQuery, s: boolean) {
  if (s) {
    selected.value.push({ ...m, memberPermission: 'editor' })
  } else {
    selected.value = selected.value.filter(s => s.userId !== m.userId)
  }
}

const modalBtns = computed<any[]>(() => {
  return [
    {
      type: 'link',
      text: '+添加成员',
      onClick: () => {
        addVisible.value = true
      },
    },
  ]
})

const shortMap: Record<MemberPermission, string> = {
  owner: '拥有者',
  manager: '可管理',
  editor: '可编辑',
  viewer: '可查看',
}

function getPermissionShortDesc(p: MemberPermission) {
  return shortMap[p]
}

const checkedKeys = computed(() => selected.value.map(item => item.id))

const handleCheck: TreeProps['onCheck'] = (keys, e) => {
  selected.value = e.checkedNodes.map(item => ({ ...item, memberPermission: 'editor' }))
}

// const treeData: TreeProps['treeData'] = [
//   {
//     title: 'parent 1',
//     key: '0-0',
//     checkable: false,
//     children: [
//       {
//         title: 'leaf4',
//         key: '0-0-0',
//       },
//       { title: 'leaf1', key: '0-0-0-0' },
//       { title: 'leaf2', key: '0-0-0-1' },
//     ],
//   },
//   {
//     title: 'parent 2',
//     key: '2',
//     checkable: false,
//     children: [{ key: '2-1', title: 'leaf3' }],
//   },
// ]

function walk(treeData: Department[]) {
  const tree = [] as Department[]
  treeData.forEach(item => {
    const ret = { ...item } as any
    const children = item.children?.map(item => ({
      ...item,
      key: item.id,
      title: item.departmentName,
      checkable: false,
    }))
    const employees = item.employeeVOList?.map(item => ({
      ...item,
      key: item.id,
      title: item.employeeName,
      disabled: props.members?.some(m => m.employeeId === item.id),
    }))
    ret.children = [] as any
    ret.employeeVOList = []
    if (children) {
      const c = walk(children)
      ret.children = c
    } else {
      ret.children = []
    }
    if (employees) {
      ret.children?.push(...employees)
    }
    tree.push(ret)
  })
  return tree
}

async function handleOpen() {
  const data = await getMemberList({ pageSize: 200, pageIndex: 1 })
  allMembers.value = data.data
  // const data = await listDepartmentEmployeeTree()
  // rawTree.value = data.departmentTreeList.map(item => ({
  //   ...item,
  //   key: item.id,
  //   title: item.departmentName,
  //   checkable: false,
  // }))
  // const tree = walk(rawTree.value)
  // orgMemberTree.value = tree
}

function removeFromSelected(s: CadFolderMemberVo) {
  selected.value = selected.value.filter(s1 => s1.userId !== s.userId)
}

function changeCurrentPermission(e: any, index: number) {
  if (props.members) {
    if (e.key === 'owner') {
      emit('transferOwner', {
        userId: props.members[index].userId,
        employeeId: props.members[index].employeeId,
      })
      return
    }
    if (e.key === 'remove') {
      const id = props.members[index].id
      const newMembers = props.members.filter(m => m.id !== id)
      emit('ok', newMembers)
      return
    }
    props.members[index].memberPermission = e.key
    emit('ok', props.members)
  }
}

function handleClose() {
  memberKeywords.value = undefined
  selected.value = []
}

function handleOk() {
  emit('ok', [...(props.members ?? []), ...selected.value])
  addVisible.value = false
  memberKeywords.value = undefined
  selected.value = []
}

watch(
  () => props.members,
  () => {
    if (rawTree.value) {
      orgMemberTree.value = walk(rawTree.value)
    }
  },
)
</script>

<style lang="less" scoped>
.title {
  font-size: 15px;
}

.title-wrapper {
  padding-right: 40px;
  height: 32px;

  .search-input {
    width: 200px;
    border-radius: 20px;
    background-color: #fbfbfb;

    :deep(.ant-input) {
      background-color: #fbfbfb;
    }
  }
}

.manage-body {
  height: 400px;

  .member-item-new {
    display: flex;
    width: calc(100% + 16px);
    transform: translateX(-8px);
    padding: 8px;
    align-items: center;
    justify-content: space-between;
    transition: all 0.28s;
    border-radius: 5px;

    .name {
      display: flex;
      align-items: center;
      > div {
        margin-right: 8px;
      }
      :deep(.ant-avatar) {
        border-radius: 50%;
      }
      .account {
        transition: all 0.28s;
        margin: 0 4px;
        color: #bbb;
      }
      .edit-icon {
        transition: all 0.28s;
        cursor: pointer;
      }
    }

    .role {
      cursor: pointer;
    }

    &:hover,
    &:focus {
      background-color: #f5f5f5;
    }

    &:focus {
      .hover-item {
        opacity: 1;
      }
    }
  }
}

.add-body {
  // border: 1px solid #f0f0f0;
  height: 600px;

  .search-input-wrapper {
    padding: 8px;
    .search-input {
      border-radius: 20px;
      background-color: #fbfbfb;

      :deep(.ant-input) {
        background-color: #fbfbfb;
      }
    }
  }

  .tree {
    height: 360px;
    overflow: auto;
  }

  > .selected {
    border-left: 1px solid #f0f0f0;
    padding: 16px;

    .selected-top {
      display: flex;
      justify-content: space-between;
      margin-top: 2px;
      margin-bottom: 20px;

      .top-left {
        font-size: 11px;
      }

      .clear-btn {
        font-size: 11px;
        color: rgb(0, 112, 221);
        cursor: pointer;
      }
    }

    // .manage-item {
    //   display: flex;
    //   justify-content: space-between;
    //   margin-bottom: 20px;

    //   .manage-left {
    //     display: flex;
    //     align-items: center;

    //     .left-avatar {
    //       width: 28px;
    //       height: 28px;
    //       background-color: rgb(0, 112, 221);
    //       border-radius: 50%;
    //       margin-right: 12px;
    //     }

    //     .left-name {
    //       font-size: 13px;
    //     }
    //   }

    // }
    // .manage-right {
    //   display: flex;
    //   align-items: center;
    //   cursor: pointer;

    //   .right-first {
    //     margin-right: 10px;
    //   }
    // }
  }
}
</style>

<style lang="less">
.permission-modal {
  .ant-modal-header {
    height: 48px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e6e6e6 !important;
  }
  .ant-modal-close-x {
    position: absolute;
    width: 24px;
    height: 24px;
    line-height: 24px;
    right: 12px;
    top: 10px;
  }
  .ant-modal-body {
    padding: 24px 32px 0 !important;
    overflow: hidden;
  }
}
</style>
